/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useRef, useState, useEffect } from "react";
import { useGLTF, Plane } from "@react-three/drei";
import { MathUtils, Box3, Vector3 } from 'three';
import { useSpring, a, config } from '@react-spring/three';

export function JavaScript(props) {
    const [isHovered, setIsHovered] = useState(false);
    const currentRotation = useRef(MathUtils.degToRad(-100))
    const [planeSize, setPlaneSize] = useState([1, 1]);
    const groupRef = useRef(); // Reference to the group

    const { rotation } = useSpring({
        from: {
        rotation: currentRotation.current
        },
        config: config.wobbly
    })
    const { nodes } = useGLTF("/models/JavaScript_model.glb");

    useEffect(() => {
      if (groupRef.current) {
          const boundingBox = new Box3().setFromObject(groupRef.current);
          const size = new Vector3();
          boundingBox.getSize(size);
          setPlaneSize([size.x + 0.5, size.y + 0.5]); // Update state with the new size
      }
    }, [props.scale]);

    useEffect(() => {
      if(isHovered){
        rotation.start({
          to: currentRotation.current + MathUtils.degToRad(35)
        })
      } else {
        rotation.start({
          to: MathUtils.degToRad(-100)
        })
      }
    }, [isHovered, rotation])

    return (
        <>
        <Plane
            args={planeSize}
            position={[props.position[0], props.position[1] - (0.25 * props.scale), props.position[2]]}
            onPointerOver={() => setIsHovered(true)}
            onPointerOut={() => setIsHovered(false)}
            visible={props.showBox}
        />
        <a.group {...props} 
            dispose={null} 
            ref={groupRef}
            rotation={[0, MathUtils.degToRad(-100), 0]}
            rotation-y={rotation}
      >
        <mesh
            castShadow
            receiveShadow
            geometry={nodes.Cube.geometry}
            material={nodes.Cube.material}
            scale={[0.161, 0.983, 0.98]}
            >
            <meshPhysicalMaterial 
                color="#f1d752" 
                metalness={0.2} 
                roughness={0.1}
                clearcoat={0.8}
                attach="material"
                
            />
        </mesh>
        <mesh
            castShadow
            receiveShadow
            geometry={nodes.Text.geometry}
            material={nodes.Text.material}
            position={[0.185, -0.776, -0.154]}
            rotation={[Math.PI / 2, 0, -Math.PI / 2]}
            scale={[1.296, 1.129, 1.129]}
            >
            <meshPhysicalMaterial 
                color="#000000" 
                metalness={0.2} 
                roughness={0.1}
                clearcoat={0.8}
                attach="material"
                
            />
        </mesh>
        </a.group>
        </>
  );
}

useGLTF.preload("/models/JavaScript_model.glb");